'use client';

import { useIsLoggedInUser } from '@packages/hooks/LoggedInUser';
import React from 'react';

interface RegisterNowButtonProps {
  registerPageUrl?: string
}

const RegisterNowButton = ({ registerPageUrl }: RegisterNowButtonProps) => {

  const [isLoggedInUser, isFetchingAuth] = useIsLoggedInUser();

  if (isFetchingAuth || isLoggedInUser)
    return <></>

  return (
    <a href={registerPageUrl || "/register/"} className="flex items-center gap-[6px] w-fit bg-primary-400 hover:bg-primary-500 text-white rounded-[20px] font-semibold text-small px-[20px] py-[10px] cursor-pointer">
      Register now
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.55556 1.55554L15 6.99999M15 6.99999L9.55555 12.4444M15 6.99999L1 6.99999" stroke="#fff" strokeWidth="1.67"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  )
}

export default RegisterNowButton;